import React, {Component} from 'react'
import _ from 'lodash'
import {StyledButton, StyledQuestionButtonNavigate} from '../../styled/StyledQuestionComponents'
import Timer from '../Timer'


class QuestionNavigation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentAnswer: {}
        }
        this.checkAnswers = this.checkAnswers.bind(this)
    }

    // verifica se a questão já possui resposta ou nao
    checkAnswers(questionCode) {

        const answer = this.props.answers
        if (_.isEmpty(answer)) {
            return !_.isEmpty(answer)
        } else {
            if (answer[questionCode] && answer[questionCode] !== '') {
                return !_.isEmpty(answer)
            }
            return false
        }

    }

    // verifica se a resposta dada está correta ou nao
    isCorrectAnswer(question) {
        const type = question && question.type
        const answer = this.props.answers
        const options = question && question.optionDTOs

        switch (type) {
            case 1: // MULTIPLE CHOICES

                const correctAnswer = _.find(options, opt => opt.isCorrectAnswer).code
                const currentAnswer = answer && answer[question.code]
               
                return (correctAnswer === currentAnswer)

            case 2: //TRUTH_OR_FALSE
                return true
            case 3: //OPEN_ANSWER
                return false
        }
    }

    // verifica se a questão foi salva ou nao
    checkSaved(questionCode) {
        const {savedQuestions} = this.props
        if (!!savedQuestions[questionCode]) {
            return true
        } else {
            return false
        }
    }

    render() {
        const question = this.props.questions
        const savedQuestions = this.props.savedQuestions
        const isReview = this.props.isReview

        const navigateButtons = question && question.map((item, key) => {
            const isCurrent = key === this.props.currentQuestion
            const isAnswered = this.props.answers && this.checkAnswers(item.code)
            const isSaved = savedQuestions && this.checkSaved(item.code)
            const isCorrect = isReview ? this.isCorrectAnswer(item) : null

            return (
                <StyledQuestionButtonNavigate
                    key={key}
                    questionDetails={item}
                    isCurrent={isCurrent}
                    isAnswered={isAnswered}
                    isSaved={isSaved}
                    isCorrect={isCorrect}
                    onClick={() => this.props.handleNavigation(key)}
                >
                    {`${(key + 1)}`.padStart(2, '0')}
                </StyledQuestionButtonNavigate>
            )
        })

        return (
            <div>
                <div className={'navigation'}>
                    <div className={'box-title'}>
                        {this.props.title}
                    </div>
                </div>

                <div className={'navigation-buttons'}>
                    {navigateButtons}
                </div>
                <div className={'timer'}>
                    {
                        !isReview && this.props.hasTime &&
                        <Timer
                            minutes={this.props.minutes}
                            seconds={this.props.seconds}
                        />
                    }

                </div>
                <div className={'send-answers'}>
                    {
                        isReview ?
                            <StyledButton
                                color={'blue'}
                                appearance="defaut"
                                onClick={() => this.props.showDefautPage(false, false)}
                            >
                                Finalizar Revisão
                            </StyledButton>
                            :
                            <StyledButton
                                color={'blue'}
                                appearance="defaut"
                                onClick={() => this.props.handleNavigation(this.props.questions.length)}
                            >
                                Finalizar Tentativa
                            </StyledButton>
                    }

                </div>
            </div>
        )
    }
}

export default QuestionNavigation



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Questions/QuestionNavigationContainer.js